import { render, staticRenderFns } from "./HistoricalActionsApiCalls.vue?vue&type=template&id=7f072d8c&scoped=true"
import script from "./HistoricalActionsApiCalls.vue?vue&type=script&lang=js"
export * from "./HistoricalActionsApiCalls.vue?vue&type=script&lang=js"
import style0 from "./HistoricalActionsApiCalls.vue?vue&type=style&index=0&id=7f072d8c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f072d8c",
  null
  
)

export default component.exports